import { ComponentProps } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/navbar.scss';
import { Box, IconButton, MenuItem } from '@mui/material';
import { ForwardRefIcon } from '@components/shared/icons/ForwardRefIcon';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

type SxProps = ComponentProps<typeof Box>['sx'];

type SearchLinkProps = {
  iconOnly?: boolean;
  sx: SxProps;
};

const SearchLink = (props: SearchLinkProps) => {
  const iconButtonStyles = {
    display: { sm: 'none', md: 'flex' },
    ...props.sx,
  };

  const navigate = useNavigate();

  if (window.settings.admin === false) {
    return null;
  }

  const onClick = () => {
    void navigate('/search');
  };

  const menuItemStyles: SxProps = {
    display: { sm: 'flex', md: 'none' },
  };

  const icon = (
    <IconButton
      size="large"
      aria-label="search"
      sx={iconButtonStyles}
      onClick={onClick}
      id="navbar_search_link"
    >
      <ForwardRefIcon icon={faSearch} />
    </IconButton>
  );

  if (props.iconOnly) {
    return icon;
  }

  return (
    <MenuItem sx={menuItemStyles} onClick={onClick}>
      Search
    </MenuItem>
  );
};

export default SearchLink;
